import { IEntityWithSoftDeleteDto } from "@Interfaces/IEntities";
import { z } from "zod";
import { EntityResponseDto } from "./entity-dto";
import { VenueResponseDto } from "./venue-dto";
import { EEventTicketType, EEventType, ESocialMedia, EStatus } from "@/Core/enums";

// Get
export interface EventResponseDto extends IEntityWithSoftDeleteDto {
    id?: string;
    name?: string;
    description?: string;
    startDate: string;
    endDate: string;
    capacity?: number;
    seats?: number;
    image?: string;
    host?: string;
    note?: string;
    price?: number;
    ticketPrice?: number;

    ticketType?: EEventTicketType;
    type?: EEventType;
    status: EStatus;
    categoryId?: string;

    category?: unknown;
    venueId: string;
    venue?: VenueResponseDto;
    entity?: EntityResponseDto;
    tickets?: [];
}

// zod schema

export const eventFormSchema = z.object({
    id: z.string().optional(),
    name: z.string(),
    description: z.string(),
    startDate: z.date(),
    endDate: z.date(),
    capacity: z.string(),
    host: z.string().optional(),
    note: z.string().optional(),
    price: z.string().default("0"),

    image: z.instanceof(File).optional(),
    ticketType: z.string(),
    type: z.string(),
    categoryId: z.string().optional(),
    venueId: z.string(),
});

// zod infer
export type EventFormDto = z.infer<typeof eventFormSchema>;

export interface SocialMediaDTo {
    type?: ESocialMedia;
    link?: string;
}

export interface AvailableScheduleDto {
    date: string;
}
export interface EventImageDto {
    Path: string;
}